import React from 'react';
import { FaPlus } from 'react-icons/fa';
import ResetPasswordButton from '../ResetPasswordButton';

const AdminManagersTab = ({ managers, handleToggleManagerStatus, setShowAddManager }) => (
  <div className="space-y-6">
    <div className="flex justify-between items-center">
      <h2 className="text-xl font-bold text-white">Manager Management</h2>
      <button
        onClick={() => setShowAddManager(true)}
        className="px-4 py-2 bg-gradient-to-r from-[#D4AF37] to-[#FFD700] text-[#0A1929] font-bold rounded-lg flex items-center space-x-2"
        data-testid="add-manager-btn"
      >
        <FaPlus /> <span>Add Manager</span>
      </button>
    </div>

    <div className="bg-gradient-to-br from-[#1A2942] to-[#1E3A5F] rounded-xl border border-[#2D5A8F] overflow-hidden">
      <table className="w-full">
        <thead className="bg-[#0F172A]">
          <tr className="text-gray-400 text-sm">
            <th className="px-4 py-3 text-left">Name</th>
            <th className="px-4 py-3 text-left">Email</th>
            <th className="px-4 py-3 text-center">Advisors</th>
            <th className="px-4 py-3 text-center">Clients</th>
            <th className="px-4 py-3 text-center">Status</th>
            <th className="px-4 py-3 text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {managers.map((manager) => (
            <tr key={manager.id} className="border-b border-[#2D5A8F]/50 hover:bg-[#1E3A5F]/50">
              <td className="px-4 py-3 text-white font-medium">{manager.name}</td>
              <td className="px-4 py-3 text-gray-300">{manager.email}</td>
              <td className="px-4 py-3 text-center text-[#FFD700] font-bold">{manager.advisor_count}</td>
              <td className="px-4 py-3 text-center text-blue-400 font-bold">{manager.client_count}</td>
              <td className="px-4 py-3 text-center">
                <span className={`px-2 py-1 rounded-full text-xs ${manager.is_active ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'}`}>
                  {manager.is_active ? 'Active' : 'Inactive'}
                </span>
              </td>
              <td className="px-4 py-3 text-center">
                <div className="flex items-center justify-center space-x-2">
                  <ResetPasswordButton
                    userId={manager.id}
                    userName={manager.name}
                    userEmail={manager.email}
                    userRole="manager"
                    resetEndpoint="admin"
                    compact={true}
                    className="p-1.5 bg-orange-500/20 hover:bg-orange-500/30 text-orange-400 rounded transition-colors"
                  />
                  <button
                    onClick={() => handleToggleManagerStatus(manager)}
                    className={`px-3 py-1 rounded text-xs ${manager.is_active ? 'bg-red-600 hover:bg-red-700' : 'bg-green-600 hover:bg-green-700'} text-white`}
                  >
                    {manager.is_active ? 'Deactivate' : 'Activate'}
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {managers.length === 0 && (
        <p className="text-gray-400 text-center py-8">No managers found</p>
      )}
    </div>
  </div>
);

export default AdminManagersTab;
